import { View } from 'components/view/view.component';
import { Text } from 'components/text/text.component';
import { TextInput } from 'components/textInput/textInput.component';
import style from './roomReservation.module.css'
import { Page } from 'components/page/page.component';
import { useEffect, useState } from 'react';
import { Select, SelectItem } from 'components/select/select.component';
import { useGetRoomsApi } from 'api/room.api';
import { Skeleton } from 'components/skeleton';
import { Button } from 'components/button/button.component';
import { DatePicker } from 'components/datePicker/datePicker.component';
import { useNavigation } from 'services/navigation.service';
import { useCreateRoomReservationApi, useGetRoomReservationApi, useUpdateRoomReservationApi } from 'api/roomReservation.api';

type RoomReservationPageProps = {
    id?: string,
    companyId?: string
}

export function RoomReservationPage({id, companyId}: RoomReservationPageProps){
    const loading = false; // Placeholder for loading state, replace with actual loading logic
    const { goBack } = useNavigation()

    const [roomId, setRoomId] = useState<string | null>(null);
    const [startTime, setStartTime] = useState<Date | null>(new Date());
    const [endTime, setEndTime] = useState<Date | null>(new Date());
    const [reservedBy, setReservedBy] = useState<string | undefined>();
    const [participants, setParticipants] = useState<number | undefined>();

    const {data: rooms, loading: roomsLoading, get: getRooms} = useGetRoomsApi()
    const {loading: roomReservationLoading, get: getRoomReservation} = useGetRoomReservationApi();
    const {create, loading: createLoading, error: createError} = useCreateRoomReservationApi();
    const {update, loading: updateLoading, error: updateError} = useUpdateRoomReservationApi();

    useEffect(()=>{
        getRooms({
            companyId: companyId || '',
            disable: false
        }).then(rooms => {
            console.log('rooms', rooms);
        }).catch(e => console.log(e.message))
    // eslint-disable-next-line
    }, [companyId]);

    useEffect(()=>{
        if(id) {
            getRoomReservation(id).then(roomReservation => {
                setRoomId(roomReservation.roomId ?? null)
                setStartTime(new Date(roomReservation.startAt))
                setEndTime(new Date(roomReservation.endAt))
                setReservedBy(roomReservation.reservedBy)
                setParticipants(roomReservation.participants)
            }).catch(e => console.log(e.message))
        }
    // eslint-disable-next-line
    }, [id]);

    function handleGoBack(){
        goBack();
    }

    async function checkFields(){
        if(!roomId) throw new Error('Selecione uma sala');
        if(!startTime) throw new Error('Selecione a data de início');
        if(!endTime) throw new Error('Selecione a data de fim');
        if(!reservedBy) throw new Error('Informe quem está reservando a sala');
        if(!participants) throw new Error('Informe o número de participantes');
        if(startTime >= endTime) throw new Error('A data de início deve ser anterior à data de fim');
        return;
    }

    function saveNewRoomReservation(reservationData: any){
        create(reservationData)
        .then(() => {
            alert('Reserva de sala criada com sucesso!');
            goBack();
        })
        .catch(e => {
            console.error(e.message);
            alert(e.message);
        });
    }

    function updateRoomReservation(id: string, reservationData: any){
        update(id, reservationData)
        .then(() => {
            alert('Reserva de sala atualizada com sucesso!');
            goBack();
        })
        .catch(e => {
            console.error(e.message);
            alert(e.message);
        });
    }

    function handleSave(){
        checkFields().then(() => {
            const reservationData = {
                roomId,
                startAt: startTime,
                endAt: endTime,
                reservedBy,
                participants
            };
            if(id) return updateRoomReservation(id, reservationData);
            return saveNewRoomReservation(reservationData);
        }).catch(e => {
            console.error(e.message);
            alert(e.message);
        });
    }
    
    return (
        <Page menu header title="Reserva de sala">
            <View className={style.Content}>
                <View className={style.FormContainer}>
                    <View className={style.Form}>
                        <View className={style.FormItemContainer}>
                            <Text type='h4'>Sala</Text>
                            <Select disabled={(id !== undefined) || createLoading || updateLoading} size='small' fullWidth value={roomId} onChange={(e)=> setRoomId(e.target.value)}>
                                { roomsLoading ? <Skeleton color='bg3'/> :
                                rooms?.map(room => (
                                    <SelectItem key={room.id} value={room.id}>
                                        {`${room.building?.name} - ${room.area?.name} - ${room.name}`}
                                    </SelectItem>
                                ))}
                            </Select>
                        </View>
                        <View className={style.FormItemContainer}>
                            <Text type='h4'>Início</Text>
                            {loading 
                            ? <Skeleton color='bg3'/>
                            : <DatePicker views={['minutes', 'hours', 'day', 'month', 'year']} sx={{width: '100%'}} disabled={false} value={startTime} onChange={_ => setStartTime(_)} />}
                        </View>
                        <View className={style.FormItemContainer}>
                            <Text type='h4'>Fim</Text>
                            {loading 
                            ? <Skeleton color='bg3'/>
                            : <DatePicker views={['minutes', 'hours', 'day', 'month', 'year']} sx={{width: '100%'}} disabled={false} value={endTime} onChange={_ => setEndTime(_)} />}
                        </View>
                        <View className={style.FormItemContainer}>
                            <Text type='h4'>Reservado por:</Text>
                            {loading 
                            ? <Skeleton color='bg3'/>
                            : <TextInput 
                                fullWidth value={reservedBy}  
                                onChange={(e)=> setReservedBy(e.target.value)} 
                                size='small'
                            />}
                        </View>
                        <View className={style.FormItemContainer}>
                            <Text type='h4'>Número de participantes:</Text>
                            {loading 
                            ? <Skeleton color='bg3'/>
                            : <TextInput 
                                fullWidth value={participants}  
                                type='number'
                                onChange={(e)=> setParticipants(parseInt(e.target.value) ?? 0)} 
                                size='small'
                            />}
                        </View>
                    </View>
                </View>
                <View className={style.Buttons}>
                    <Button onClick={handleGoBack}>Voltar</Button>
                    <Button variant='contained' onClick={handleSave}>Salvar</Button>
                </View>
            </View>    
        </Page>
    );
}